import React from 'react';
import { Grid } from '@mui/material';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div>
      <Header />
      <Grid className="container-main" container spacing={3} sx={{ justifyContent: 'center' }}>
        {children}
      </Grid>
    </div>
  );
};

export default Layout;